
import React, { useEffect, useState } from "react";
import Setor from "../../../../model/administracao/cadastro/Setor";
import UsuarioLogadoService from "../../../../service/usuario/UsuarioLogadoService";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import { useToastContext } from "components/alert/ToastContext";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Label } from "components/input/Label";
import AuditoriaAppService from "service/auditoria5s/AuditoriaAppService";
import { Dropdown } from "primereact/dropdown";
import { PeriodicidadeService } from "service/periodicidade/PeriodicidadeService";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    onConfirm: () => void;
}

const auditoriaAppService = new AuditoriaAppService();
const periodicidadeService = new PeriodicidadeService();
export default function ModalGerarAuditoria(props: Props) {

    const { msgErro } = useToastContext();

    const [setores, setSetores] = useState<Setor[]>([]);
    const [setorSelecionado, setSetorSelecionado] = useState<Setor | null>(null);

    const [geraParaOutrosSetores, setGeraParaOutrosSetores] = useState(false);

    const [planos, setPlanos] = useState<SetorPlanoAuditoria[]>([])
    const [planoSelecionado, setPlanoSelecionado] = useState<SetorPlanoAuditoria | null>(null);

    useEffect(() => {
        auditoriaAppService.geraParaOutrosSetores().then(json => {
            setGeraParaOutrosSetores(json as boolean);
            if (json) {
                auditoriaAppService.setores().then(json => {
                    setSetores(json);
                }).catch(err => {
                    console.error(err);
                });
            } else {
                auditoriaAppService.planosUsuarioLogado().then(json => {
                    setPlanos(json);
                }).catch(err => {
                    console.error(err);
                });
            }
        }).catch(err => {
            console.error(err);
        })

    }, []);

    function gerarPlano() {
        if (planoSelecionado) {
            auditoriaAppService.gerarAuditoria(planoSelecionado.id).then(json => {
                props.onConfirm();
                props.setVisible(false);

            }).catch(err => {
                console.error(err);
                if (err && err.data && err.data.message) {
                    msgErro('Erro', err.data.message);
                } else {
                    msgErro('Erro', 'Ocorreu um erro ao gerar a auditoria');
                }
            })
        }
    }


    return (

        <Dialog visible={props.visible} onHide={() => props.setVisible(false)} header="Gerar Auditoria" footer={<>
            <Button onClick={() => props.setVisible(false)}>Cancelar</Button>
            <Button disabled={planoSelecionado == null} onClick={() => gerarPlano()}>Gerar</Button>
        </>}>
            {geraParaOutrosSetores ? <div style={{ display: 'flex', flexDirection: 'column', rowGap: 4, columnGap: 4 }}>
                <Label>Setor</Label>
                <Dropdown placeholder="Selecione o setor" style={{ marginBottom: 4 }} onChange={(e) => {
                    setSetorSelecionado(e.target.value);
                    setPlanos(e.target.value.planos);
                    setPlanoSelecionado(null);
                }} options={setores} optionLabel="nome" value={setorSelecionado}
                />
            </div> : null}
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 4, columnGap: 4 }}>
                <Label >Plano</Label>
                <Dropdown
                    itemTemplate={(option: SetorPlanoAuditoria) => {
                        const limiteText = option.limite?.ativa ?
                            option.limite.periodo + " " + periodicidadeService.getTipoPeriodo(option.limite.tipoPeriodo)?.label
                            : "Inativo"
                        return (
                            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 2 }}>
                                <span>
                                    <strong>{option?.setor?.nome}</strong> - {option?.planoAuditoria?.nome}
                                </span>
                                <span style={{ color: "#555" }}>Limite: {limiteText}</span>
                            </div>
                        )
                    }}
                    style={{ marginBottom: 4 }} disabled={planos.length === 0}
                    placeholder={planos.length === 0 ? 'Nenhum plano disponível' : 'Selecione o plano'}
                    options={planos} optionLabel="planoAuditoria.nome" value={planoSelecionado}
                    onChange={(e) => {
                        setPlanoSelecionado(e.target.value);
                    }}
                />
            </div>


        </Dialog>
    )
}